import { fromJS } from "immutable";
import Highcharts from "highcharts";
import React, { PureComponent } from "react";
import HighchartsReact from "highcharts-react-official";

class DefaultChart extends PureComponent {
  render() {
    const { options } = this.props;

    const mergedOptions = fromJS(Highcharts.defaultOptions)
      .mergeDeep(fromJS(options))
      .toJS();

    return <HighchartsReact highcharts={Highcharts} options={mergedOptions} />;
  }
}

export default DefaultChart;
